import * as log from "loglevel";
import { ACTIONS, CO_BROWSE_SESSION_STATUS } from "UTILS/Constants";
import { socketMessage } from "WEBSOCKET/constants";
import { customerCoBrowseAction } from "CONFIG/ActionFactory";
log.setLevel("info");

export const handleMessage = (data, store) => {
  switch (data.action) {
    case socketMessage.subCategories.CUSTOMER_CO_BROWSE._PERMISSION_REQUEST:
      store.dispatch({
        type: ACTIONS.CUSTOMER_CO_BROWSE.SET_CUSTOMER_CO_BROWSE_REQUEST,
        value: true,
        layoutCode: data.layoutDetails
      });
      store.dispatch({
        type: ACTIONS.CUSTOMER_CO_BROWSE.SET_CUSTOMER_CO_BROWSE_DATA,
        roomId: data.roomId,
        shareUrl: data.shareUrl,
        layoutCode: data.layoutDetails,
        serverName: data.serverName
      })
      store.dispatch({
        type: ACTIONS.CUSTOMER_CO_BROWSE.CUSTOMER_CO_BROWSE_PARTICIPANT_STATUS_UPDATE,
        uniqueId: store.getState().RoomMetaDataReducer.roomMetaData.presenterId,
        value: true
      })
      break;

    case socketMessage.subCategories.CUSTOMER_CO_BROWSE._PERMISSION_REPLY:
      if (data && data.uniqueId && !data.isGranted) {
        store.dispatch({
          type: ACTIONS.CUSTOMER_CO_BROWSE.CUSTOMER_CO_BROWSE_PERMISSION_DENIDED,
          value: data.uniqueId,
          layoutCode: data.layoutCode
        });
      }
      break;

    case socketMessage.subCategories.CUSTOMER_CO_BROWSE._PARTICIPANT_ARRIVED:
      store.dispatch({
        type: ACTIONS.CUSTOMER_CO_BROWSE.CUSTOMER_CO_BROWSE_JOIN_SESSION,
        value: data.uniqueId
      });
      store.dispatch({
        type: ACTIONS.CUSTOMER_CO_BROWSE.CUSTOMER_CO_BROWSE_PARTICIPANT_STATUS_UPDATE,
        uniqueId: data.uniqueId,
        value: true
      });
      break;
    case socketMessage.subCategories.CUSTOMER_CO_BROWSE._END_SESSION:
      // When the owner has finished co-browsing, the follower's reconnection information is also deleted.
      sessionStorage.removeItem('reconnectionUrlForFollower');
      store.dispatch({
        type: ACTIONS.CUSTOMER_CO_BROWSE.CUSTOMER_CO_BROWSE_END_SESSION
      });
      break;

    //is PARTICIPANT_LEFT call
    case socketMessage.subCategories.CUSTOMER_CO_BROWSE._LEAVE_SESSION:
      customerCoBrowseAction.leaveCustomerCoBrowse(data.uniqueId)
      break;

    case socketMessage.subCategories.CUSTOMER_CO_BROWSE._FOLLOWER_EDIT:
      console.log(data)
      
      const iframeEle = document.getElementById("customerCBIframe");
      if (iframeEle) {
        const iframe = iframeEle.contentWindow;
        const msg = {
          action: "follower_edit",
          followerEdit: data.toggleFlag,
        };

        iframe.postMessage(msg, data.coBrowseBaseUrl);
      }
  
      break;
  }
};
